export default "__VITE_ASSET__d6999009__"